<template>
  <div v-if="shouldRender" :class="classModifiers">
    <div class="market-ownership-and-orders-bar__ownership" :class="ownershipClassModifiers">
      <template v-if="hasOwnership">
        <span v-if="showOwnershipIcon" class="market-ownership-and-orders-bar__icon"></span>
        <span class="market-ownership-and-orders-bar__quantity">{{
          ownershipQuantityDisplay
        }}</span>
        <span class="market-ownership-and-orders-bar__mode">{{ ownershipModeDisplay }}</span>
        <span class="market-ownership-and-orders-bar__average">
          (<span v-price-display.cents="ownershipAverage"></span>&nbsp;avg)
        </span>
        <market-change-price
          v-if="ownershipDifference"
          class="market-ownership-and-orders-bar__change"
          :price="ownershipDifference"
        ></market-change-price>
      </template>
      <template v-else>
        <span class="market-ownership-and-orders-bar__ownership-empty">No ownership</span>
      </template>
    </div>
    <div v-if="showOrdersSummary" class="market-ownership-and-orders-bar__orders">
      <template v-if="hasOrders || showZeroOrders">
        <span v-if="!hideOrdersLabel" class="market-ownership-and-orders-bar__orders-label"
          >Orders:</span
        >
        <span
          class="market-ownership-and-orders-bar__orders-count market-ownership-and-orders-bar__orders-count--buy"
          >{{ buyOrdersDisplay }}</span
        >
        <span class="market-ownership-and-orders-bar__orders-text">Buy</span>
        <span class="market-ownership-and-orders-bar__orders-separator">/</span>
        <span
          class="market-ownership-and-orders-bar__orders-count market-ownership-and-orders-bar__orders-count--sell"
          >{{ sellOrdersDisplay }}</span
        >
        <span class="market-ownership-and-orders-bar__orders-text">Sell</span>
      </template>
      <span v-else class="market-ownership-and-orders-bar__orders-empty">No orders</span>
    </div>
  </div>
</template>

<script src="./market-ownership-and-orders-bar.js"></script>
<style src="./market-ownership-and-orders-bar.scss" lang="scss"></style>
